import { render, staticRenderFns } from "./CardSupport.vue?vue&type=template&id=0e82374a&scoped=true&"
import script from "./CardSupport.vue?vue&type=script&lang=js&"
export * from "./CardSupport.vue?vue&type=script&lang=js&"
import style0 from "./CardSupport.vue?vue&type=style&index=0&id=0e82374a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82374a",
  null
  
)

export default component.exports